import Encoding from "encoding-japanese";

// See documentation: https://www.npmjs.com/package/encoding-japanese
const convertToJis = (text: string) => {
  const unicodeArray = Encoding.stringToCode(text);
  const sjisArray = Encoding.convert(unicodeArray, {
    to: "SJIS",
    from: "UNICODE",
    type: "array",
  });
  return Encoding.urlEncode(sjisArray);
};

type DownloadFileOptions = {
  filename: string;
  content: string;
  encoding: "utf-8" | "Shift_JIS";
};

/* Encode the file, create a link to it, then simulate a click on the link to download it */
export const downloadFile = ({
  filename,
  content,
  encoding,
}: DownloadFileOptions) => {
  let convertedContent: string;
  if (encoding === "Shift_JIS") {
    convertedContent = convertToJis(content);
  } else {
    convertedContent = encodeURI(content);
  }

  const encodedUri = `data:text/csv;charset=${encoding},\uFEFF${convertedContent}`;
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  // Filename should already include .csv extension from the caller
  const downloadFilename = filename.endsWith(".csv")
    ? filename
    : `${filename}.csv`;
  link.setAttribute("download", downloadFilename);
  document.body.appendChild(link);
  link.click();
};
